
function extractFromUrl (param, location)  {
  return new URLSearchParams(location.search).get(param)
}

/**
 * Returns a mutable copy of the query string as it is in the address bar
 * right now. Use this, not the `searchParams` value from `useSearchParams`,
 * when building an update to pass to `setSearchParams`.
 *
 * react-router v7 commits location changes inside React.startTransition, so
 * the `searchParams` a component rendered with can lag behind the real URL.
 * Writing from that snapshot silently reverts params another component has
 * just set (for example `activeTab`). `history.pushState` updates
 * `window.location` synchronously, so reading it here is always current.
 */
export function liveSearchParams () {
  return new URLSearchParams(window.location.search)
}

export default {extractFromUrl, liveSearchParams}
